/**
 * Shown when a Supply User tries to change a promo start date that has already
 * passed. Such a promo can still be extended, but its start is settled (HTT-9780).
 */
export const PAST_START_DATE_MESSAGE =
  "Start date in the past cannot be changed";

// EO-1538: read-only banner for a Campaign promo opened from the promotions table.
// Placeholder copy — to be confirmed by product.
export const CAMPAIGN_PROMO_READONLY_MESSAGE =
  "This is a Campaign promo managed by Hotel Trader. Its configuration is view-only.";
